import request from '@/middleware/request'

const listFlowUi = () => {
  return request({
    url: `/flow/list`,
    method: 'get'
  })
}

const listFlowUiByPlatform = platform => {
  return request({
    url: `/flow/list/${platform}`,
    method: 'get'
  })
}

const createFlowUi = data => {
  return request({
    url: '/flow',
    method: 'post',
    data
  })
}

const updateFlowUi = (id, data) => {
  return request({
    url: `/flow/${id}`,
    method: 'patch',
    data
  })
}

const deleteFlowUi = id => {
  return request({
    url: `/flow/${id}`,
    method: 'delete'
  })
}

const importFlowUi = data => {
  return request({
    url: '/flow/import',
    method: 'post',
    data: data
  })
}

const getFlowUi = id => {
  return request({
    url: `/flow/get/${id}`,
    method: 'get'
  })
}

const getFlowUiDescription = id => {
  return request({
    url: `/flow/description/${id}`,
    method: 'get'
  })
}

const saveFlowUi = (id, data) => {
  return request({
    url: `/flow/save/${id}`,
    method: 'post',
    data
  })
}

const cloneFlowUi = (id, data) => {
  return request({
    url: `/flow/clone/${id}`,
    method: 'post',
    data
  })
}

const getSecureUrl = data => {
  return request({
    url: `/flow/chat/getSecureUrl`,
    method: 'post',
    data: {
      path: data
    }
  })
}

const uploadFlowMailAttachment = formData => {
  return request({
    url: '/flow_mail_attachment/upload',
    method: 'post',
    timeout: 300000, // 5 mins
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

const getMailAttachmentFileUrl = file_id => {
  return request({
    url: `/flow_mail_attachment/${file_id}`,
    method: 'get',
    responseType: 'blob'
  })
}

export default {
  listFlowUi,
  listFlowUiByPlatform,

  createFlowUi,
  updateFlowUi,
  deleteFlowUi,
  importFlowUi,

  getFlowUi,
  getFlowUiDescription,
  saveFlowUi,
  cloneFlowUi,

  getSecureUrl,
  uploadFlowMailAttachment,
  getMailAttachmentFileUrl
}
